import { styled, Box } from '@withjoy/joykit';
import { animationTransition } from '@shared/utils/animationTransition';

export const ToggleWrapper = styled(Box)<{ isMobile?: boolean }>`
  height: 36px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  transition: ${animationTransition('background-color', 'box-shadow', 'color')};
  color: ${props => props.theme.colors.mono10};
  text-decoration: none;
  min-width: ${({ isMobile }) => (isMobile ? '152px' : 'initial')};
  flex: 1;
  cursor: pointer;

  &.active {
    color: ${props => props.theme.colors.mono14};
  }

  &.disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;
